
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34202',
  depVersions: {
  "documents-public-ui": "static-1.34202",
  "client-types": "static-1.454",
  "documents-lib": "static-1.34207",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2013",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4921",
  "highcharts": "static-8.101",
  "hs-promise-utils": "static-1.5480",
  "hs-test-utils": "static-1.7897",
  "hub-http": "static-1.6104",
  "hubspot-dlb": "static-2.1828",
  "HubStyleTokens": "static-2-me-set-font-family-mixin.4",
  "I18n": "static-7.1598",
  "jasmine-immutable": "static-1.2903",
  "jasmine-runner": "static-1.6355",
  "lodash": "static-1.3",
  "quartz": "static-1.6847",
  "react": "static-7.183",
  "react-dlb": "static-1.75",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.69",
  "react-rhumb": "static-1.16539",
  "reporting-data": "static-1.66941",
  "reporting-testing-lib": "static-1.8874",
  "reporting-visualizations": "static-1.59017",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4654",
  "webpack-env": "static-1.54",
  "atom": "static-1.4955",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2379",
  "classnames": "static-2.10",
  "cssUtils": "static-1.764",
  "customer-data-filters-ui": "static-1.39269",
  "customer-data-objects": "static-1.7539",
  "customer-data-property-utils": "static-1.7968",
  "data-fetching-client": "static-1.9561",
  "enviro": "static-4.425",
  "FireAlarmUi": "static-1.4414",
  "flux-actions": "static-1.323",
  "FormsCommonComponents": "static-1.85529",
  "FormUrlGenerator": "static-2.4605",
  "foundations-components": "static-1.7690",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4034",
  "HubStyle": "static-2-me-set-font-family-mixin.4",
  "icons": "static-2-me-set-font-family-mixin.2",
  "immutable": "static-2.76",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7045",
  "metrics-js": "static-1.9522",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.386",
  "property-description-translator": "static-1.3740",
  "property-translator": "static-1.5295",
  "quartz-config": "static-1.625",
  "quartz-core": "static-1.6066",
  "quick-fetch": "static-1.3819",
  "raven": "static-3.5808",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5252",
  "react-virtualized": "static-2.96",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8051",
  "reference-resolvers-lite": "static-1.7974",
  "report-customization-components": "static-1.12788",
  "reporting-enablement": "static-1.22432",
  "reporting-reports": "static-1.66619",
  "reporting-snowflake": "static-1.55559",
  "reporting-ui-components": "static-2.64212",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4528",
  "sales-content-partitioning": "static-1.8822",
  "SalesContentIndexUI": "static-3.9058",
  "sanitize": "static-1.4358",
  "sanitize-text": "static-1.8030",
  "self-service-api": "static-1.10130",
  "SharedI18nStrings": "static-1.181",
  "SharedLegalStrings": "static-1.1637",
  "signup-constants": "static-1.18624",
  "signup-ui-lego-core": "static-1.20634",
  "signup-ui-url-generator": "static-2.7924",
  "styled-components": "static-2.87",
  "StyleGuideUI": "static-3.485",
  "superstore": "static-1.4654",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10877",
  "ui-addon-i18n": "static-1.11032",
  "ui-addon-react-router-dom": "static-1.9430",
  "ui-addon-upgrades": "static-9.17809",
  "ui-asset-management-lib": "static-1.10853",
  "ui-images": "static-2-me-set-font-family-mixin.2",
  "UIComponents": "static-3-me-set-font-family-mixin.4",
  "usage-tracker": "static-1.7221",
  "usage-tracker-container": "static-1.7211",
  "usage-tracker-core": "static-1.7071",
  "usage-tracker-public": "static-1.7032",
  "viral-links-lib": "static-1.6922",
  "hs-promise-rejection-tracking": "static-1.5473",
  "raven-hubspot": "static-1.6115",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3309",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3124",
  "quartz-webpack": "static-1.3071",
  "ai-components-ui-library": "static-1.8631",
  "amplitude-session-replay-browser": "static-1.57",
  "foundations-assets": "static-1.4729",
  "foundations-theming": "static-1.4297",
  "quartz-auth": "static-1.522",
  "ui-business-units-lib": "static-1.8924",
  "usage-tracker-session-replay": "static-1.4907",
  "foundations-theming-base": "static-1.3282",
  "HeadJS": "static-2.732",
  "framer-motion": "static-1.69",
  "hs-test-utils-bend-plugin": "static-1.3008",
  "msw": "static-1.39",
  "testing-library": "static-1.149",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.80",
  "jasmine": "static-4.4210",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7809",
  "graphql": "static-1.79",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3494",
  "persist-promise": "static-1.3594",
  "reporting-client-types": "static-1.2426",
  "foundations-components-legacy": "static-1.715",
  "hs-story-utils": "static-1.9314",
  "react-flip-move": "static-1.67",
  "hub-http-shared-msw-handlers": "static-1.9697",
  "hubspotter-http": "static-1.4556",
  "sassPrefix": "static-1.153",
  "conversations-skeleton-state": "static-1.7134",
  "crm-message-bus": "static-1.42645",
  "customer-data-filters-ui-msw-helpers": "static-1.21704",
  "customer-data-objects-ui-components": "static-1.12902",
  "customer-data-reference-ui-components": "static-1.13038",
  "customer-data-ui-utilities": "static-1.9710",
  "framework-builder-read-service-client": "static-1.3913",
  "framework-data-schema-quick-fetch": "static-1.6665",
  "framework-data-schema-resolvers": "static-1.6760",
  "inbound-db-properties-service-client": "static-1.3750",
  "multi-account-reference-resolvers": "static-1.868",
  "onboarding-tours": "static-1.16391",
  "reporting-datasets-permissions-lib": "static-1.13335",
  "ui-addon-teams": "static-1.21385",
  "apollo-stack-hubspot": "static-3.83",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67963",
  "customer-data-properties": "static-1.51121",
  "forms-ai-lib": "static-1.4139",
  "forms-utils-lib": "static-1.12360",
  "foundations-components-test-utils": "static-1.5173",
  "react-dnd-compat": "static-1.4504",
  "react-tinymce": "static-1.54896",
  "tinymce-config": "static-2.54022",
  "ui-gdpr-components": "static-1.10233",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3959",
  "floating-ui": "static-1.53",
  "react-aria": "static-1.63",
  "tanstack-table": "static-1.52",
  "trellis-assets": "static-1.1480",
  "ui-fonts": "static-1-me-set-font-family-mixin.4",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.816",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.20",
  "quartz-head": "static-1.512",
  "quartz-i18n": "static-1.522",
  "quartz-routing": "static-1.277",
  "quartz-test": "static-1.522",
  "quartz-tracking": "static-1.226",
  "batch-promise": "static-1.1437",
  "external-options-client-types": "static-1.4063",
  "react-colorpicker": "static-2.10095",
  "copilot-toolkit": "static-1.10796",
  "data-quality-ui-library": "static-1.12554",
  "html-to-image": "static-1.51",
  "markdown-it": "static-1.6",
  "onboarding-scopes": "static-1.6348",
  "reporting-action-components": "static-1.40925",
  "reporting-insights-lib": "static-1.1358",
  "reporting-plugins": "static-1.10114",
  "ui-addon-draggable-compat": "static-2.4139",
  "ui-addon-opt": "static-4.8268",
  "ui-shepherd-react": "static-3.10032",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.25005",
  "hubspot-apollo-client": "static-1.4764",
  "chirp-fetch": "static-1.1767",
  "sales-templates-service-types-lib": "static-1.4071",
  "merchandise-lib": "static-1.261",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5652",
  "salesImages": "static-1.522",
  "ts-schema": "static-1.3983",
  "timezone-utils": "static-2.5129",
  "bender-build-tools": "static-1.3041",
  "chatspot-core": "static-1.20753",
  "bend-plugin-foundations-theming": "static-1.2780",
  "stylex": "static-1.29",
  "hubspotter-http-shared-msw-handlers": "static-1.9695",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3702",
  "crm-pipelines-api-client-types": "static-1.4047",
  "multi-currency-client-types": "static-1.3594",
  "getting-started-shared-tasks": "static-1.18155",
  "growth-data-modal": "static-1.5251",
  "growth-onboarding-confetti": "static-1.2957",
  "growth-onboarding-next-action-utils": "static-1.1563",
  "navigation-components": "static-1.17595",
  "onboarding-tours-client": "static-1.4605",
  "onboarding-tours-utils": "static-1.457",
  "ui-shepherd-tracker": "static-1.7413",
  "ui-universal-auth": "static-1.8813",
  "user-context": "static-1.4985",
  "cms-field-types": "static-1.4694",
  "content-icons-ui": "static-1.2191",
  "integrations-lib": "static-1.15721",
  "calling-global-api": "static-1.64042",
  "calling-internal-common": "static-1.31187",
  "calling-lifecycle-internal": "static-1.65424",
  "calling-lifecycle-messages": "static-1.57718",
  "commerce-products-lib": "static-1.9110",
  "crm-links": "static-1.6159",
  "file-manager-components": "static-1.23241",
  "google-libphonenumber": "static-1.35",
  "hs-resources": "static-1.20",
  "inbounddb-objects-service-types": "static-1.4127",
  "meetings-icalendar-utils-lib": "static-1.516",
  "object-builder-ui-client": "static-1.48338",
  "pipeline-validation-client-types": "static-1.3869",
  "property-value-citations": "static-1.1735",
  "pulse": "static-1.418",
  "smart-property-lib": "static-1.6367",
  "tiered-pricing": "static-1.986",
  "ui-addon-iframeable": "static-1.8935",
  "final-form": "static-1.67",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19632",
  "tinymce-themes": "static-1.55992",
  "data-token-picker": "static-1.16203",
  "hub-http-contrib": "static-1.2928",
  "interframe": "static-3.4648",
  "tinymce-data": "static-1.40107",
  "tinymce-plugins": "static-1.57136",
  "ui-addon-sales-email": "static-1.5097",
  "magpie-lib": "static-1.5479",
  "magpie-types": "static-1.4939",
  "simple-logging-lib": "static-1.2936",
  "content-assistance-lib": "static-1.7579",
  "dashboard-lib": "static-1.81019",
  "ExportDialog": "static-6.10274",
  "hubspot-prosemirror": "static-1.17888",
  "hubspot-prosemirror-plugins": "static-1.17880",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8578",
  "campaign-roi-lib": "static-1.8581",
  "feedback-loader": "static-1.29072",
  "apollo-link-hub-http": "static-2.4536",
  "hubspot-apollo-cache": "static-1.223",
  "growth-monetization-service-types": "static-1.4385",
  "nav-client-types": "static-1.2243",
  "purchase-motions-api": "static-1.5655",
  "trials-service-types": "static-1.3786",
  "onboarding-data-sync-lib": "static-1.1767",
  "growth-onboarding-next-action-components": "static-1.1591",
  "user-context-client": "static-1.4497",
  "idb-keyval": "static-1.41",
  "nest": "static-1.107",
  "reactive-lib": "static-1.609",
  "unified-auth-core-lib": "static-1.608",
  "getting-started-shared-tasks-store": "static-1.17273",
  "integrations-error-boundary-lib": "static-1.13136",
  "integrations-tracking-lib": "static-1.5480",
  "native-integrations-shared-strings": "static-1.7672",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10259",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.327",
  "calling-error-reporting": "static-1.31193",
  "shared-worker-versioning": "static-1.10924",
  "calling-usage-tracker": "static-1.6427",
  "voice-sms-access-library": "static-1.540",
  "customer-data-tracking": "static-1.6768",
  "commerce-permissions": "static-1.650",
  "products-iframe-lib": "static-1.7595",
  "products-ui-components-shared-msw-handlers": "static-1.10079",
  "location-customization-utils-lib": "static-1.8861",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.4038",
  "video-components-external": "static-1.10883",
  "video-data-lib": "static-1.34541",
  "directed-graph": "static-1.823",
  "event-emitter": "static-1.833",
  "fast-json-patch": "static-1.60",
  "breeze-intelligence-kit": "static-1.5453",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9780",
  "fsm": "static-1.3619",
  "policy-lib": "static-1.6668",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9843",
  "navigation-messaging": "static-1.6922",
  "FileManagerLib": "static-1.38881",
  "NamespacedHubStyle": "static-2.8973",
  "FileManagerCore": "static-1.38740",
  "codemirror": "static-5.92",
  "layout-dnd-components": "static-1.12222",
  "layout-dnd-utils": "static-1.11197",
  "react-codemirror": "static-1.10509",
  "ui-addon-emoji-picker": "static-1.9772",
  "ui-brand-identity-lib": "static-1.14666",
  "ui-addon-video-player": "static-1.8581",
  "ui-coaching-tips": "static-1.28202",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8438",
  "payment-link-components": "static-1.23193",
  "EmailSignatureEditor": "static-1.24108",
  "eligibility-engine-service-types": "static-1.3067",
  "InboxConnectUtils": "static-4.14479",
  "universal-page-editor-lib": "static-1.2891",
  "calling-orchestration-schema": "static-1.35317",
  "sales-views-client-types": "static-1.4148",
  "crm-record-cards-service-types": "static-1.3515",
  "content-media-composition-data-lib": "static-1.11840",
  "content-media-compositions": "static-2.15847",
  "media-bridge-lib": "static-1.18723",
  "trellis-story-utils": "static-1.4405",
  "storybook-react": "static-1.30",
  "audio-components": "static-1.5742",
  "FileManagerImages": "static-1.36392",
  "video-components": "static-1.12886",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4417",
  "video-embed": "static-1.35375",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68038",
  "layout-data-lib": "static-1.9522",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6466",
  "commerce-tours-lib": "static-1.5881",
  "growth-onboarding-reliability": "static-1.4972",
  "sales-checkout-service-client": "static-1.3553",
  "draft-convert": "static-2.70",
  "draft-extend": "static-3.72",
  "draft-js": "static-5.75",
  "draft-plugins": "static-2.21471",
  "sales-email-signature-service-client": "static-1.3728",
  "social-insights-client-types": "static-1.21713",
  "outpost": "static-1.4082",
  "advanced-menus-core": "static-1.14949",
  "advanced-menus-lib": "static-1.11913",
  "ui-memberships-settings-lib": "static-1.33710",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14948",
  "simple-menus-lib": "static-1.16465"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34202",
  "client-types": "/client-types/static-1.454",
  "documents-lib": "/documents-lib/static-1.34207",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2013",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4921",
  "highcharts": "/highcharts/static-8.101",
  "hs-promise-utils": "/hs-promise-utils/static-1.5480",
  "hs-test-utils": "/hs-test-utils/static-1.7897",
  "hub-http": "/hub-http/static-1.6104",
  "hubspot-dlb": "/hubspot-dlb/static-2.1828",
  "HubStyleTokens": "/HubStyleTokens/static-2-me-set-font-family-mixin.4",
  "I18n": "/I18n/static-7.1598",
  "jasmine-immutable": "/jasmine-immutable/static-1.2903",
  "jasmine-runner": "/jasmine-runner/static-1.6355",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6847",
  "react": "/react/static-7.183",
  "react-dlb": "/react-dlb/static-1.75",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.69",
  "react-rhumb": "/react-rhumb/static-1.16539",
  "reporting-data": "/reporting-data/static-1.66941",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8874",
  "reporting-visualizations": "/reporting-visualizations/static-1.59017",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4654",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4955",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2379",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.764",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39269",
  "customer-data-objects": "/customer-data-objects/static-1.7539",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7968",
  "data-fetching-client": "/data-fetching-client/static-1.9561",
  "enviro": "/enviro/static-4.425",
  "FireAlarmUi": "/FireAlarmUi/static-1.4414",
  "flux-actions": "/flux-actions/static-1.323",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85529",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4605",
  "foundations-components": "/foundations-components/static-1.7690",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4034",
  "HubStyle": "/HubStyle/static-2-me-set-font-family-mixin.4",
  "icons": "/icons/static-2-me-set-font-family-mixin.2",
  "immutable": "/immutable/static-2.76",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7045",
  "metrics-js": "/metrics-js/static-1.9522",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.386",
  "property-description-translator": "/property-description-translator/static-1.3740",
  "property-translator": "/property-translator/static-1.5295",
  "quartz-config": "/quartz-config/static-1.625",
  "quartz-core": "/quartz-core/static-1.6066",
  "quick-fetch": "/quick-fetch/static-1.3819",
  "raven": "/raven/static-3.5808",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5252",
  "react-virtualized": "/react-virtualized/static-2.96",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8051",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7974",
  "report-customization-components": "/report-customization-components/static-1.12788",
  "reporting-enablement": "/reporting-enablement/static-1.22432",
  "reporting-reports": "/reporting-reports/static-1.66619",
  "reporting-snowflake": "/reporting-snowflake/static-1.55559",
  "reporting-ui-components": "/reporting-ui-components/static-2.64212",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4528",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8822",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9058",
  "sanitize": "/sanitize/static-1.4358",
  "sanitize-text": "/sanitize-text/static-1.8030",
  "self-service-api": "/self-service-api/static-1.10130",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1637",
  "signup-constants": "/signup-constants/static-1.18624",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20634",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7924",
  "styled-components": "/styled-components/static-2.87",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "superstore": "/superstore/static-1.4654",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10877",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11032",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9430",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17809",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10853",
  "ui-images": "/ui-images/static-2-me-set-font-family-mixin.2",
  "UIComponents": "/UIComponents/static-3-me-set-font-family-mixin.4",
  "usage-tracker": "/usage-tracker/static-1.7221",
  "usage-tracker-container": "/usage-tracker-container/static-1.7211",
  "usage-tracker-core": "/usage-tracker-core/static-1.7071",
  "usage-tracker-public": "/usage-tracker-public/static-1.7032",
  "viral-links-lib": "/viral-links-lib/static-1.6922",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5473",
  "raven-hubspot": "/raven-hubspot/static-1.6115",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3309",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3124",
  "quartz-webpack": "/quartz-webpack/static-1.3071",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8631",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.57",
  "foundations-assets": "/foundations-assets/static-1.4729",
  "foundations-theming": "/foundations-theming/static-1.4297",
  "quartz-auth": "/quartz-auth/static-1.522",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8924",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4907",
  "foundations-theming-base": "/foundations-theming-base/static-1.3282",
  "HeadJS": "/HeadJS/static-2.732",
  "framer-motion": "/framer-motion/static-1.69",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3008",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.149",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.80",
  "jasmine": "/jasmine/static-4.4210",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7809",
  "graphql": "/graphql/static-1.79",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3494",
  "persist-promise": "/persist-promise/static-1.3594",
  "reporting-client-types": "/reporting-client-types/static-1.2426",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.715",
  "hs-story-utils": "/hs-story-utils/static-1.9314",
  "react-flip-move": "/react-flip-move/static-1.67",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9697",
  "hubspotter-http": "/hubspotter-http/static-1.4556",
  "sassPrefix": "/sassPrefix/static-1.153",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7134",
  "crm-message-bus": "/crm-message-bus/static-1.42645",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21704",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12902",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13038",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9710",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3913",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6665",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6760",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3750",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.868",
  "onboarding-tours": "/onboarding-tours/static-1.16391",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13335",
  "ui-addon-teams": "/ui-addon-teams/static-1.21385",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.83",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67963",
  "customer-data-properties": "/customer-data-properties/static-1.51121",
  "forms-ai-lib": "/forms-ai-lib/static-1.4139",
  "forms-utils-lib": "/forms-utils-lib/static-1.12360",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5173",
  "react-dnd-compat": "/react-dnd-compat/static-1.4504",
  "react-tinymce": "/react-tinymce/static-1.54896",
  "tinymce-config": "/tinymce-config/static-2.54022",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10233",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3959",
  "floating-ui": "/floating-ui/static-1.53",
  "react-aria": "/react-aria/static-1.63",
  "tanstack-table": "/tanstack-table/static-1.52",
  "trellis-assets": "/trellis-assets/static-1.1480",
  "ui-fonts": "/ui-fonts/static-1-me-set-font-family-mixin.4",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.20",
  "quartz-head": "/quartz-head/static-1.512",
  "quartz-i18n": "/quartz-i18n/static-1.522",
  "quartz-routing": "/quartz-routing/static-1.277",
  "quartz-test": "/quartz-test/static-1.522",
  "quartz-tracking": "/quartz-tracking/static-1.226",
  "batch-promise": "/batch-promise/static-1.1437",
  "external-options-client-types": "/external-options-client-types/static-1.4063",
  "react-colorpicker": "/react-colorpicker/static-2.10095",
  "copilot-toolkit": "/copilot-toolkit/static-1.10796",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12554",
  "html-to-image": "/html-to-image/static-1.51",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-scopes": "/onboarding-scopes/static-1.6348",
  "reporting-action-components": "/reporting-action-components/static-1.40925",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1358",
  "reporting-plugins": "/reporting-plugins/static-1.10114",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4139",
  "ui-addon-opt": "/ui-addon-opt/static-4.8268",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10032",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.25005",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4764",
  "chirp-fetch": "/chirp-fetch/static-1.1767",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4071",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5652",
  "salesImages": "/salesImages/static-1.522",
  "ts-schema": "/ts-schema/static-1.3983",
  "timezone-utils": "/timezone-utils/static-2.5129",
  "bender-build-tools": "/bender-build-tools/static-1.3041",
  "chatspot-core": "/chatspot-core/static-1.20753",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2780",
  "stylex": "/stylex/static-1.29",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9695",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3702",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4047",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3594",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18155",
  "growth-data-modal": "/growth-data-modal/static-1.5251",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2957",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1563",
  "navigation-components": "/navigation-components/static-1.17595",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4605",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.457",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7413",
  "ui-universal-auth": "/ui-universal-auth/static-1.8813",
  "user-context": "/user-context/static-1.4985",
  "cms-field-types": "/cms-field-types/static-1.4694",
  "content-icons-ui": "/content-icons-ui/static-1.2191",
  "integrations-lib": "/integrations-lib/static-1.15721",
  "calling-global-api": "/calling-global-api/static-1.64042",
  "calling-internal-common": "/calling-internal-common/static-1.31187",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65424",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57718",
  "commerce-products-lib": "/commerce-products-lib/static-1.9110",
  "crm-links": "/crm-links/static-1.6159",
  "file-manager-components": "/file-manager-components/static-1.23241",
  "google-libphonenumber": "/google-libphonenumber/static-1.35",
  "hs-resources": "/hs-resources/static-1.20",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4127",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.516",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48338",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3869",
  "property-value-citations": "/property-value-citations/static-1.1735",
  "pulse": "/pulse/static-1.418",
  "smart-property-lib": "/smart-property-lib/static-1.6367",
  "tiered-pricing": "/tiered-pricing/static-1.986",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8935",
  "final-form": "/final-form/static-1.67",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19632",
  "tinymce-themes": "/tinymce-themes/static-1.55992",
  "data-token-picker": "/data-token-picker/static-1.16203",
  "hub-http-contrib": "/hub-http-contrib/static-1.2928",
  "interframe": "/interframe/static-3.4648",
  "tinymce-data": "/tinymce-data/static-1.40107",
  "tinymce-plugins": "/tinymce-plugins/static-1.57136",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5097",
  "magpie-lib": "/magpie-lib/static-1.5479",
  "magpie-types": "/magpie-types/static-1.4939",
  "simple-logging-lib": "/simple-logging-lib/static-1.2936",
  "content-assistance-lib": "/content-assistance-lib/static-1.7579",
  "dashboard-lib": "/dashboard-lib/static-1.81019",
  "ExportDialog": "/ExportDialog/static-6.10274",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17888",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17880",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8578",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8581",
  "feedback-loader": "/feedback-loader/static-1.29072",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4536",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.223",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4385",
  "nav-client-types": "/nav-client-types/static-1.2243",
  "purchase-motions-api": "/purchase-motions-api/static-1.5655",
  "trials-service-types": "/trials-service-types/static-1.3786",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1767",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1591",
  "user-context-client": "/user-context-client/static-1.4497",
  "idb-keyval": "/idb-keyval/static-1.41",
  "nest": "/nest/static-1.107",
  "reactive-lib": "/reactive-lib/static-1.609",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.608",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17273",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13136",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5480",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7672",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10259",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.327",
  "calling-error-reporting": "/calling-error-reporting/static-1.31193",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10924",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6427",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.540",
  "customer-data-tracking": "/customer-data-tracking/static-1.6768",
  "commerce-permissions": "/commerce-permissions/static-1.650",
  "products-iframe-lib": "/products-iframe-lib/static-1.7595",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10079",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8861",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.4038",
  "video-components-external": "/video-components-external/static-1.10883",
  "video-data-lib": "/video-data-lib/static-1.34541",
  "directed-graph": "/directed-graph/static-1.823",
  "event-emitter": "/event-emitter/static-1.833",
  "fast-json-patch": "/fast-json-patch/static-1.60",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5453",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9780",
  "fsm": "/fsm/static-1.3619",
  "policy-lib": "/policy-lib/static-1.6668",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9843",
  "navigation-messaging": "/navigation-messaging/static-1.6922",
  "FileManagerLib": "/FileManagerLib/static-1.38881",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8973",
  "FileManagerCore": "/FileManagerCore/static-1.38740",
  "codemirror": "/codemirror/static-5.92",
  "layout-dnd-components": "/layout-dnd-components/static-1.12222",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11197",
  "react-codemirror": "/react-codemirror/static-1.10509",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9772",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14666",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8581",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28202",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8438",
  "payment-link-components": "/payment-link-components/static-1.23193",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24108",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3067",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14479",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2891",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35317",
  "sales-views-client-types": "/sales-views-client-types/static-1.4148",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3515",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11840",
  "content-media-compositions": "/content-media-compositions/static-2.15847",
  "media-bridge-lib": "/media-bridge-lib/static-1.18723",
  "trellis-story-utils": "/trellis-story-utils/static-1.4405",
  "storybook-react": "/storybook-react/static-1.30",
  "audio-components": "/audio-components/static-1.5742",
  "FileManagerImages": "/FileManagerImages/static-1.36392",
  "video-components": "/video-components/static-1.12886",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4417",
  "video-embed": "/video-embed/static-1.35375",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68038",
  "layout-data-lib": "/layout-data-lib/static-1.9522",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6466",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5881",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4972",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3553",
  "draft-convert": "/draft-convert/static-2.70",
  "draft-extend": "/draft-extend/static-3.72",
  "draft-js": "/draft-js/static-5.75",
  "draft-plugins": "/draft-plugins/static-2.21471",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3728",
  "social-insights-client-types": "/social-insights-client-types/static-1.21713",
  "outpost": "/outpost/static-1.4082",
  "advanced-menus-core": "/advanced-menus-core/static-1.14949",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11913",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33710",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14948",
  "simple-menus-lib": "/simple-menus-lib/static-1.16465"
}
};
